const urlRegex = /^https?:\/\/[\w/:%#$&?()~.=+-]+$/;
export const imageCodeRegex = /^https:\/\/[a-zA-Z]+\.blob\.core\.windows\.net\/.+\.(jpeg|jpg|png|gif)\?[\w/:%#$&?()~.=+-]+$/i;
export const videoCodeRegex = /^https:\/\/[a-zA-Z]+\.blob\.core\.windows\.net\/.+\.mp4?[\w/:%#$&?()~.=+-]+$/i;

export const validateUrl = (url: string) => {
    return urlRegex.test(url);
};
